import { useEffect, useState } from "react";
import { Star } from "lucide-react";
import "./ReviewForm.css";

export default function EditReviewForm({ comment, rate }) {
    const [rateUser, setRateUser] = useState(0);
    const [hover, setHover] = useState(0);

    useEffect(() => {
        if (comment) {
            setRateUser(rate.rate);
        }
    }, [rate]);

    return (
        <div className="review-rating">
            <h3>
                شما قبلاً برای این محصول نظر ثبت کرده‌اید.
            </h3>
            <div className="stars">
                {[1, 2, 3, 4, 5].map((star) => (
                    <Star
                        key={star}
                        size={28}
                        strokeWidth={1.8}
                        className={`rating-star ${star <= (hover || rateUser) ? "active" : ""
                            }`}
                        onMouseEnter={() => setHover(star)}
                        onMouseLeave={() => setHover(0)}
                        onClick={() => setRateUser(star)}
                    />
                ))}
            </div>


            <div className="inner">
                <div className="p-2 text-justify">


                    <p>{comment?.comment}</p>
                    <small>{comment?.created_at}</small>


                </div>
            </div>
        </div>
    );
}